export default function linearScale(
  domain: [number, number],
  range: [number, number],
) {
  return (value: number): number => {
    return (
      ((value - domain[0]) / (domain[1] - domain[0])) * (range[1] - range[0]) +
      range[0]
    );
  };
}
